<template>
  <v-footer app padless absolute v-if="!this.isMessage">
    <div class="footer-wrap">
      <div class="footer-main">
        <router-link to="/">首页</router-link>
        <router-link to="/nav">导航</router-link>
        <router-link to="/works">产品</router-link>
        <router-link to="/story">故事</router-link>
        <router-link to="/about">关于</router-link>
      </div>
      <div class="footer-copy">
        © 2022 - {{ new Date().getFullYear() }}
        {{ blogInfo.webSite.author || profile.name }}
      </div>
      <div class="footer-visits" v-if="viewsCount">
        站内文章累计阅读 {{ viewsCount.toLocaleString() }} 次
      </div>
      <div class="footer-icp">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
          {{ icp }}
        </a>
      </div>
    </div>
  </v-footer>
</template>

<script>
import { profile } from "@/assets/js/profile";

export default {
  data() {
    return { profile };
  },
  computed: {
    isMessage() {
      return this.$route.path == "/message";
    },
    blogInfo() {
      return this.$store.state.blogInfo;
    },
    // 旧 count.viewsCount 来自文章 quantity 相加，不是全站访客数。
    viewsCount() {
      return (this.blogInfo.count && this.blogInfo.count.viewsCount) || 0;
    },
    // 优先用前端配置的完整备案号，库里那份没有 -1 后缀
    icp() {
      return profile.icp || this.blogInfo.webSite.recordNum;
    }
  }
};
</script>

<style scoped>
.footer-wrap {
  width: 100%;
  position: relative;
  padding: 44px 20px 32px;
  text-align: center;
  background: var(--bg-alt);
  border-top: 1px solid var(--border);
}
.footer-main {
  margin-bottom: 20px;
}
.footer-main a {
  color: var(--ink-mid) !important;
  margin: 0 14px;
  font-size: 14px;
  transition: color 0.2s;
}
.footer-main a:hover {
  color: var(--accent) !important;
}
.footer-copy {
  font-size: 13.5px;
  color: var(--ink-soft);
  line-height: 2;
}
.footer-visits {
  font-size: 13px;
  color: var(--ink-faint);
  line-height: 2;
}
.footer-icp a {
  font-size: 13px;
  color: var(--ink-faint) !important;
}
.footer-icp a:hover {
  color: var(--ink-soft) !important;
}

@media (max-width: 760px) {
  .footer-wrap {
    padding: 32px 16px 24px;
  }
  .footer-main a {
    margin: 0 9px;
    line-height: 2.2;
    font-size: 13.5px;
  }
}
</style>
